<template>
  <AdFormBanner
    v-if="!isLiveBlogArticle"
    :key="bannerKey"
    ad-type="header"
    :settings="{
      mid: headerAd.mid,
      adBlockFallback: headerAd.adb,
      group: headerAd.group,
    }"
  />
</template>

<script>
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';

export default {
  components: {
    AdFormBanner,
  },
  props: {
    bannerKey: {
      required: true,
    },
    headerAd: {
      required: true,
    },
  },
  computed: {
    isLiveBlogArticle() {
      const article = this.$store.getters['article/getActiveArticle'];

      return article?.settings?.articleTemplate === 'liveBlog';
    },
  },
};
</script>
